export var NavigationApp;
(function (NavigationApp) {
    NavigationApp["GoogleMaps"] = "googlemaps";
    NavigationApp["Waze"] = "waze";
    NavigationApp["AppleMaps"] = "applemaps";
})(NavigationApp || (NavigationApp = {}));
export var FloatingMarkerPosition;
(function (FloatingMarkerPosition) {
    FloatingMarkerPosition["Top"] = "top";
    FloatingMarkerPosition["Right"] = "right";
    FloatingMarkerPosition["Bottom"] = "bottom";
    FloatingMarkerPosition["Left"] = "left";
})(FloatingMarkerPosition || (FloatingMarkerPosition = {}));
